module.exports = __webpack_public_path__ + "img/da707.350ca65b.svg";